<template>
  <EdroneAlert class="tw:w-full tw:border-0 tw:border-b tw:border-default-200 tw:rounded-none tw:p-4" type="ai">
    <template #custom-icon>
      <i class="fa-kit fa-solid-chart-line-sparkle"></i>
    </template>

    <template #custom-content>
      <div class="tw:flex tw:flex-col">
        <p class="tw:body-2--bold tw:mb-1 tw:text-default-700">{{ trans._readyFlows.smartInsight.header.title }}</p>
        <p class="tw:body-2 tw:mb-3 tw:text-default-700">{{ trans._readyFlows.smartInsight.header.desc }}</p>
        <div>
          <EdroneButton size="medium" unique-id="smart-insight-check-insight-btn" @click="$emit('click')">
            {{ trans._readyFlows.smartInsight.header.btn }}
            <template #right-icon>
              <FontAwesomeIcon icon="fa-light fa-arrow-right" />
            </template>
          </EdroneButton>
        </div>
      </div>
    </template>
  </EdroneAlert>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneAlert from "edrone-components/EdroneAlert.vue";

defineEmits(["click"]);
</script>
